import Login from '@shared/features/login/Login';

const ChromeLogin = ({ headerText }: { headerText?: string }) => {
  return (
    <Login
      authBaseUrl={import.meta.env.VITE_API_BASE_URL}
      displayLogo={false}
      appName="Sidekick"
      headerText={headerText}
    />
  );
};

export default ChromeLogin;
